module.exports = __webpack_public_path__ + "img/clipboard.0eb9e74e.svg";